import useTranslator from '~/lib/useTranslator'

export const FraudReportSection = ({
  className,
  fundraiserSlug,
}: {
  className?: string
  fundraiserSlug: string
}) => {
  const Translator = useTranslator()

  const subject = encodeURIComponent('Fraud Report - Heja Shop')
  const body = encodeURIComponent(
    `Hello Heja Team,\n\nI would like to report a potential case of fraud that I have encountered on the Heja platform. Here are the details:\n\n[Please provide a detailed description of the issue, including any relevant information such as dates, times, usernames, and any other pertinent details.]\n\n\n\n\n\n\n [Below are automatically included information about the fundraiser. Please do not remove this section as it helps us investigate the issue more efficiently.]\n\nFundraiser slug: ${fundraiserSlug}`
  )

  return (
    <section className={`bg-gray-100 p-8 flex items-center justify-center ${className || ''}`}>
      <div className="max-w-screen-sm mx-auto text-center">
        <h2 className="text-2xl font-semibold mb-4">{Translator.singular('Report fundraiser')}</h2>
        <p className="mt-2 text-sm text-gray-600">
          {Translator.singular(
            'Report this fundraiser if you believe it may be misleading or violating our terms.'
          )}
        </p>
        <a
          href={`mailto:privacy@heja.io?subject=${subject}&body=${body}`}
          className="mt-4 inline-flex items-center gap-2 text-sm font-medium underline text-black"
        >
          {Translator.singular('Report fundraiser to Heja')}
        </a>
      </div>
    </section>
  )
}
